import { Layout } from '@/core/layout/layout';
import { type RouteRecordRaw } from 'vue-router';

export default {
    path: '/incorporation-funnel/:id',
    name: 'incorporation-funnel',
    component: () => import('@/components/Funnel/IncorporationFunnel/views/IncorporationFunnel.vue'),
    meta: {
        private: true,
        layout: Layout.HeaderOnly,
    },
    children: [
        {
            path: 'shareholders',
            name: 'incorporation-shareholders',
            component: () => import('@/components/Funnel/IncorporationFunnel/components/Shareholders.vue'),
        },
        {
            path: 'details',
            name: 'incorporation-details',
            component: () => import('@/components/Funnel/IncorporationFunnel/components/Details.vue'),
        },
        {
            path: 'documents',
            name: 'incorporation-documents',
            component: () => import('@/components/Funnel/IncorporationFunnel/components/Documents.vue'),
        },
        {
            path: 'payment',
            name: 'incorporation-payment',
            component: () => import('@/components/Funnel/IncorporationFunnel/components/Payment.vue'),
        },
        {
            path: 'notary',
            name: 'incorporation-notary',
            component: () => import('@/components/Funnel/IncorporationFunnel/components/Notary.vue'),
        },
        {
            path: 'upsells',
            name: 'incorporation-upsells',
            component: () => import('@/components/Funnel/IncorporationFunnel/components/Upsells.vue'),
        },
        {
            path: ':(.*)',
            redirect: { name: 'incorporation-funnel' },
        },
    ],
} as RouteRecordRaw;
